<template>
  <div class="loading" @click="closeLoading">
    <img class="cyberboard" :src="images.cyberboard" />
    <img class="logo" :src="images.logo_square" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "CLoading",
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
  },
  methods: {
    closeLoading() {
      this.$emit("click");
    },
  },
  mounted() {
    setTimeout(this.closeLoading, 4000);
  },
};
</script>

<style lang="scss" scoped>
.loading {
  width: 100vw;
  height: 100vh;
  background: #171717;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  cursor: pointer;

  .cyberboard {
    width: 1200px;
    max-width: 1920px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .logo {
    width: 250px;
    position: fixed;
    left: 50%;
    top: 20%;
    transform: translate(-50%, -50%);
  }
}
</style>
